import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  private readonly _http = inject(HttpClient);

  private readonly _memberUrl = environment.memberUrl;
  private readonly _baseUrl = environment.apiUrl;

  get(memberId: number, teamId: number, databaseId: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/member-info/${databaseId}/${teamId}/${memberId}`);
  }

  getClub(teamId: number, databaseId: number): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/get-club-info/${databaseId}/${teamId}`);
  }

  getSharingInfo(): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/shareBirthdayData`);
  }

  updateAdvertisementView(data: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/allow-advertisment`, data);
  }

  updateBirthdaySharing(data: any): Observable<any> {
    return this._http.post<any>(`${this._baseUrl}/share-birthday`, data);
  }

  updateBank(data: any) {
    return this._http.post<any>(`${this._baseUrl}/bank-info`, data);
  }

  validateIban(iban: string): Observable<any> {
    return this._http.get<any>(`${this._baseUrl}/validate-iban/${iban}`);
  }
}
